module.exports = __webpack_public_path__ + "static/media/group_icon.ba5cc7c7.png";